let currentPlat = '';
let timer = null;
function resizeHandler() {
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(function() {
    const { plat } = usePlat();
    if (currentPlat && plat !== currentPlat) {
      removeResizeListener();
      return window.location.reload();
    }
    setHtmlFontSize();
    timer = null;
  }, 100);
}

function resizeListener() {
  window.addEventListener('resize', resizeHandler);
}
function removeResizeListener() {
  window.removeEventListener('resize', resizeHandler);
}

let hasListener = false;

function getBodyFontSize() {
  const bodyElement = document.body;
  const computedStyle = window.getComputedStyle(bodyElement);
  return computedStyle.getPropertyValue('font-size');
}

function setHtmlFontSize() {
  const { isPC } = usePlat();
  if (!hasListener) {
    if (import.meta.env.MODE !== 'production') {
      resizeListener();
    }
    hasListener = true;
  }
  if (!isPC) {
    const scale = 37.5 / 375;
    const bodyWidth = document.documentElement.getBoundingClientRect().width; // 当前窗口的宽度
    const rem = bodyWidth * scale;
    const remPx = rem + 'px';
    document.body.style.fontSize = getBodyFontSize();
    document.documentElement.style.fontSize = remPx;
    return { width: bodyWidth, fontSize: rem };
  }
}

export const useRemResize = () => {
  const { plat } = usePlat();
  currentPlat = plat;
  setHtmlFontSize();
};
